module.exports = __webpack_public_path__ + "img/ETAG.f5ac9e87.jpg";